import React from 'react'

export default function InformacionLaboral() {
  return (
    <div>
      InformacionLaboral
    </div>
  )
}
